import { createStore } from 'vuex';
import user from "./user";
import ai from "./ai";
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
    key: "user-vuex",
    storage: window.localStorage,
    reducer: state => ({
        user: {
            loggedIn: state.user.loggedIn,
            userProfile: state.user.userProfile,
            isAuthenticatedForBMS: state.user.isAuthenticatedForBMS
        },
        ai: {
            selectedSession: state.ai.selectedSession,
            selectedProject: state.ai.selectedProject
        }
    })
});

export const store = createStore({
    modules: {
        user,
        ai,
    },
    plugins: [vuexLocal.plugin]
});
